<template>
    <dialog-generic :visibility.sync = 'visibility' :indicator = 'indicator'>
        <template v-slot:title>Изменить отчет</template>
        <template v-slot:content>
            <v-form class = 'px-4'>
                <v-text-field v-model = 'report.name' label='Название отчета'></v-text-field>
                <v-text-field v-model = 'report.description' label='Описание отчета'></v-text-field>
                <v-text-field disabled v-model = 'report.report_id' label='Внешний ID отчета'></v-text-field>
                <v-text-field disabled v-model = 'report.group_id' label='Внешний ID группы'></v-text-field>
            </v-form>
        </template>
        <template v-slot:action>
            <v-btn class = 'px-0 light-blue--text text--darken-2' :loading = 'indicator' block depressed @click = 'updateReport'>Изменить</v-btn>
        </template>
    </dialog-generic>
</template>
<script>
    import DialogGeneric from '@/components/elements/dialogs/Generic.vue'

    export default {
        name: 'ReportUpdateDialog',
        props: ['initialState', 'data', 'postAction'],
        components: {'dialog-generic': DialogGeneric},
        data() {
            return {
                visibility: this.initialState,
                report: this.data,
                indicator: false
            }
        },
        watch: {
            initialState(value) {
                this.visibility = value
            },
            visibility(value) {
                this.$emit('update:initialState', value);
            },
            data(value) {
                this.report = value
            }
        },
        methods: {
            updateReport() {
                this.indicator = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': 'Bearer ' + String(this.$store.getters.userToken)
                }
                let requestData = {
                    'login': this.$store.getters.userLogin,
                    'report_id': this.report.report_id
                }
                this.$http.put(this.$store.getters.endpoint + '/db/reports', { ...requestData, ...this.report }, {
                    headers: { ...this.$store.state.restrictedHeaders, ...requestHeaders }
                }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.indicator = false;
                        this.$dataLayer.$emit('enrich', {
                            event: 'crud',
                            data: {
                                type: 'update',
                                target: 'report'
                            },
                            once: false
                        })
                        this.postAction && this.postAction();
                        this.$emit('requestUpdateReportsList', 'requestUpdateReportsList')
                        this.visibility = false;
                    } else {
                        console.log(response)
                    }
                })
            }
        }
    }
</script>